module.exports = __webpack_public_path__ + "src/assets/img/afishadaily.24de7d33.jpg";